import Axios from 'axios';

export const createCancelToken = () => {
  const cancelSource = Axios.CancelToken.source();
  return {
    token: cancelSource.token,
    cancel: cancelSource.cancel,
  };
};
